import { useEffect } from "react";

// Google Play compliance page — the actual, canonical content lives at the
// static HTML file `/delete-account.html` in `public/` so the page works
// even if the SPA bundle fails to load. This React route hard-redirects
// clients (that arrive via SPA navigation) to that static file.
export default function DeleteAccount() {
  useEffect(() => {
    window.location.replace("/delete-account.html");
  }, []);
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#F9F9F6",
        color: "#2C3326",
        fontFamily:
          "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 24px",
      }}
      data-testid="delete-account-redirect"
    >
      <div style={{ textAlign: "center", maxWidth: 460 }}>
        <p
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 300,
            letterSpacing: "0.32em",
            fontSize: 16,
            marginBottom: 20,
          }}
        >
          MATCHA·STORY
        </p>
        <p style={{ color: "#6B715F", fontSize: 14, lineHeight: 1.7 }}>
          Loading account deletion page…{" "}
          <a
            href="/delete-account.html"
            style={{
              color: "#5A6B3E",
              textDecoration: "underline",
              textUnderlineOffset: 3,
            }}
          >
            Click here if you are not redirected.
          </a>
        </p>
      </div>
    </div>
  );
}
